import styled from "styled-components";
import Button from "./Button";

export const GreenButton = styled(Button)`
    background-color: #2fd566
`;


// WEBPACK FOOTER //
// ./src/components/Button/GreenButton.js